import styled from 'styled-components';
import BackButton from '../utils/back_button';
import { blog8 } from "../../../assets/images";
import { useNavigate } from 'react-router-dom';
import OtherBlogs from '../our_blogs/OtherBlogs';
import CTASection from "../../landing/landing_home/empower"

const Blog8 = () => {
   const navigate = useNavigate();
      const handleBackClick = () => {
         window.scrollTo(0, 0);
         navigate("/blog")
      };

  return (
     <>
     <Fullpage>
     <PageBackground>
    <BlogContainer>
      <BlogWrapper>
        <HeaderSection>
          <NavigationSection>
            <BackButton onClick={handleBackClick} />
          </NavigationSection>
          <BlogHeader
            title="Multilingual Support in Campus Insights"
            date="August 7, 2025"
            author="POSTED BY CAMPUS INSIGHTS"
          />
        </HeaderSection>

        <HeroImage
          src={blog8}
          alt="Multilingual Support in Campus Insights"
        />

        <BlogContent />
      </BlogWrapper>
    </BlogContainer>
    <OtherBlogs currentBlogId={8} />
    </PageBackground>
    </Fullpage>
    <CTASection />
  </>
  );
};

const BlogHeader = ({ title, date, author }) => {
  return (
    <HeaderContainer>
      <Title>{title}</Title>
      <MetadataContainer>
        <MetadataWrapper>
          <MetadataGroup>
            <DateText>{date}</DateText>
            <AuthorText>• {author}</AuthorText>
          </MetadataGroup>
        </MetadataWrapper>
      </MetadataContainer>
    </HeaderContainer>
  );
};

const BlogContent = () => {
  return (
    <ContentContainer>
      <IntroText>
        Multilingual support in Campus Insights plays a critical role in fostering inclusivity, equity, and student success by enabling institutions to better serve students from diverse linguistic and cultural backgrounds. Here's how:
      </IntroText>

      <BlogSection
        title="🌍 1. Improves Access for Non-Native English Speakers"
        content="Many students and families—especially from immigrant, refugee, or international backgrounds—may struggle to understand complex academic, financial aid, or enrollment information in English. Multilingual AI-powered support ensures they receive accurate and timely information in their preferred language, reducing barriers to access."
      />

      <BlogSection
        title="🗣️ 2. Builds Trust and Engagement"
        content="When students and families see information presented in their home language, it builds trust. It signals that the institution values their identity and voice, which can enhance engagement and increase comfort in asking questions or seeking help."
      />

      <BlogSection
        title="📈 3. Boosts Retention and Success"
        content="By providing clear guidance on deadlines, resources, and processes in multiple languages, Campus Insights reduces the likelihood of students missing critical information. This supports timely enrollment, financial aid compliance, and academic progress, all of which positively impact student retention and completion."
      />

      <BlogSection
        title="🤝 4. Supports Families and Caregivers"
        content="In many communities, families are deeply involved in education decisions. Multilingual support ensures that parents or guardians—who may not speak English—can participate meaningfully in conversations about financial aid, student progress, and available support services."
        image="https://api.builder.io/api/v1/image/assets/TEMP/d08cde32527cdd1d1174a57dc132816dcea395f4?width=1526"
      />

      <BlogSection
        title="🔄 5. Real-Time, Culturally-Aware Interaction"
        content="Campus Insights' generative AI allows for real-time conversation translation and context-sensitive responses, allowing for more personalized and respectful interactions across languages. It adapts to regional language nuances, improving communication effectiveness."
      />

      <ConclusionSection>
        <ConclusionTitle>Conclusion</ConclusionTitle>
        <ConclusionContent>
          <ConclusionText>
            Multilingual support in Campus Insights is more than just a feature—it's a pathway to educational equity. It ensures all students, regardless of linguistic background, receive the information and guidance they need to thrive in college.
            <br />
            <br />
            Would you like a slide version or 1-pager of this for stakeholders or grant proposals?
            <br />
            <br />
            You said:
            <br />
            one pager for stakeholders
            <br />
            <br />
            ChatGPT said:
            <br />
            Here's a polished one-pager for stakeholders on Multilingual Support in Campus Insights—focused on impact, equity, and engagement.
          </ConclusionText>
        </ConclusionContent>
      </ConclusionSection>
    </ContentContainer>
  );
};

const BlogSection = ({ title, content, image, imageAlt }) => {
  return (
    <SectionContainer>
      <SectionTitle>{title}</SectionTitle>
      <ContentWrapper>
        {image && (
          <SectionImage
            src={image}
            alt={imageAlt || ''}
          />
        )}
        <ContentText>{content}</ContentText>
      </ContentWrapper>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SectionTitle = styled.h2`
  color: #1c1b1f;
  letter-spacing: -0.32px;
  width: 100%;
  font: 700 32px/120% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 28px;
  }
  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SectionImage = styled.img`
  width: 100%;
  max-width: 763px;
  height: 400px;
  border-radius: 16px;
  object-fit: cover;
  @media (max-width: 991px) {
    height: 300px;
  }
  @media (max-width: 640px) {
    height: 240px;
  }
`;

const ContentText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;


const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const IntroText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;

const ConclusionSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const ConclusionTitle = styled.h2`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.32px;
  font: 700 32px/120% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 28px;
  }
  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

const ConclusionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const ConclusionText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: italic 400 16px/160% Inter, sans-serif;
  margin: 0;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;


const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const Title = styled.h1`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.48px;
  font: 700 48px/120% Inter, sans-serif;
  margin: 0;
  @media (max-width: 991px) {
    font-size: 40px;
  }
  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 110%;
  }
`;

const MetadataContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const MetadataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const MetadataGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const DateText = styled.time`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const AuthorText = styled.span`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const BlogContainer = styled.article`
  display: flex;
  width: 100%;
  max-width: 1120px;
  padding: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  border-radius: 24px;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: #fff;
  @media (max-width: 991px) {
    padding: 40px 32px;
    gap: 48px;
  }
  @media (max-width: 640px) {
    padding: 24px 16px;
    gap: 32px;
  }
`;

const BlogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  width: 100%;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
`;

const NavigationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 16px;
  object-fit: cover;
  @media (max-width: 991px) {
    height: 300px;
  }
  @media (max-width: 640px) {
    height: 240px;
  }
`;

const PageBackground = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 500px, #F5F5F9 100px, #F5F5F9 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 200px 0;
    flex-direction: column;

  @media (max-width: 640px) {
    padding: 40px 0;
    background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 100px, #ffffff 100px, #ffffff 100%);
  }
`;

const Fullpage = styled.div`
  height: 100%;
  width: 100%;
//   background-color: #e20707ff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
 

  @media (max-width: 640px) {
    padding: 40px 0;
   
  }
`;

export default Blog8;
